import { render, staticRenderFns } from "./AddVideo.vue?vue&type=template&id=38cfd8b2"
import script from "./AddVideo.vue?vue&type=script&lang=ts"
export * from "./AddVideo.vue?vue&type=script&lang=ts"
import style0 from "./AddVideo.vue?vue&type=style&index=0&id=38cfd8b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports